import type { UserNode } from '@/modules/users'
import { usePermissionsOrMe } from '@/utils/hooks'
import type { PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  user: Pick<UserNode, 'id'>
  permissions: string | string[]
  allowAdmin?: boolean
}
export function PermissionsOrMeRequired({
  children,

  user,
  permissions,
  allowAdmin = false,
}: Props) {
  const hasPerms = usePermissionsOrMe(user, allowAdmin)

  const permsArr = typeof permissions === 'string' ? [permissions] : permissions
  if (!hasPerms(...permsArr)) return null

  return children
}
